import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

export const MarkDown = ({
  content,
  theme = 'default'
}: {
  content: string;
  theme?: 'default' | 'success' | 'error';
}) => {
  const getHeadingClasses = () => {
    switch (theme) {
      case 'success':
        return 'text-green-600 dark:text-green-400';
      case 'error':
        return 'text-red-600 dark:text-red-400';
      default:
        return 'text-gray-800 dark:text-gray-200';
    }
  };

  const headingClasses = getHeadingClasses();

  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      components={{
        p: ({ children }) => <p className="text-sm leading-relaxed mb-2">{children}</p>,
        b: ({ children }) => <b className="text-sm leading-relaxed mb-2">{children}</b>,
        h1: ({ children }) => (
          <h1 className={`text-lg font-bold mt-4 mb-2 ${headingClasses}`}>{children}</h1>
        ),
        h2: ({ children }) => (
          <h2 className={`text-base font-bold mt-3 mb-2 ${headingClasses}`}>{children}</h2>
        ),
        h3: ({ children }) => (
          <h3 className={`text-base font-bold mt-3 mb-2 ${headingClasses}`}>{children}</h3>
        ),
        h4: ({ children }) => (
          <h4 className={`text-sm font-semibold mt-2 mb-1 ${headingClasses}`}>{children}</h4>
        ),
        a: ({ href, children }) => (
          <a
            href={href}
            className="text-sm text-blue-600 dark:text-blue-400 hover:underline"
            target="_blank"
            rel="noopener noreferrer">
            {children}
          </a>
        ),
        ul: ({ children }) => <ul className="list-disc ml-4 my-2 space-y-1">{children}</ul>,
        ol: ({ children }) => <ol className="list-decimal ml-4 my-2 space-y-1">{children}</ol>,
        li: ({ children }) => <li className="text-sm leading-relaxed">{children}</li>,
        code: ({ children }) => (
          <code className="text-xs bg-gray-100 dark:bg-gray-800 px-1 py-0.5 rounded">
            {children}
          </code>
        ),
        pre: ({ children }) => (
          <pre className="text-xs bg-gray-100 dark:bg-gray-800 p-3 rounded my-2 overflow-x-auto">
            {children}
          </pre>
        )
      }}>
      {content}
    </ReactMarkdown>
  );
};

export default MarkDown;
